exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".widget-health .health-icon[data-v-410524a6] {\n  color: rgba(0, 0, 0, 0.2);\n}", ""]);

// exports
